import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import * as _ from "lodash";
import { sortBy, includes, upperFirst } from "lodash";

@Component({
  selector: "user-logins-table",
  templateUrl: "./user-logins-table.component.html",
  styleUrls: ["./user-logins-table.component.scss"],
})
export class UserLoginsTableComponent implements OnInit {
  @Input() userLogins;

  dates: string[];

  displayedColumns: string[];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor() {}

  ngOnInit() {
    this.dates = [];
    if (this.userLogins.length > 0) {
      this.dates = (<any>Object)
        .keys(this.userLogins[0].views)
        .sort()
        .reverse();
      this.dates = this.sortByMonth(this.dates);
    }
    this.displayedColumns = [
      "email",
      "name",
      "school",
      "role",
      "everLoggedIn",
      "lastLoggedIn",
      ...this.dates.map((month) => month.toLowerCase()), // angular material sort doesn't work for uppercase col names
    ];
    this.userLogins = sortBy(this.userLogins, ["name"]);
    this.dataSource = new MatTableDataSource(this.userLogins);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (
      data: any,
      sortHeaderId: string
    ): string => {
      if (sortHeaderId == "lastLoggedIn") return data["lastLogin"];
      let month = upperFirst(sortHeaderId);
      if (includes(this.dates, month)) {
        return data.views[month].viewCount;
      }
      return data[sortHeaderId];
    };
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  sortByMonth(dates: Array<string>) {
    if (dates.indexOf("December") > -1 && dates.indexOf("January") > -1) {
      var months = [
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "Current",
      ];
    } else {
      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
        "Current",
      ];
    }
    return dates.sort(function (a, b) {
      return months.indexOf(a) - months.indexOf(b);
    });
  }
}
